function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const COLUMN_1 = {
  links: [{
    intlLabelKey: 'trade',
    intlDescriptionKey: 'tradeDescription',
    intlLinkTitleKey: 'tradeLinkTitle',
    intlIconAltTextKey: 'tradeIconAltText',
    url: 'https://www.coinbase.com/signup',
    iconType: 'pictogram',
    iconName: 'coinbaseLogoNavigation'
  }, {
    intlLabelKey: 'advancedTrade',
    intlDescriptionKey: 'advancedTradeDescription',
    intlLinkTitleKey: 'advancedTradeLinkTitle',
    intlIconAltTextKey: 'advancedTradeIconAltText',
    url: 'https://www.coinbase.com/advanced-trade'
  }, {
    intlLabelKey: 'wallet',
    intlDescriptionKey: 'walletDescription',
    intlLinkTitleKey: 'walletLinkTitle',
    intlIconAltTextKey: 'walletIconAltText',
    url: 'https://www.coinbase.com/wallet',
    iconType: 'pictogram',
    iconName: 'walletLogoNavigation'
  }, {
    intlLabelKey: 'earn',
    intlDescriptionKey: 'newEarnDescription',
    intlLinkTitleKey: 'earnLinkTitle',
    intlIconAltTextKey: 'earnIconAltText',
    url: 'https://www.coinbase.com/earn',
    iconType: 'pictogram',
    iconName: 'earnNavigation'
  }, {
    intlLabelKey: 'card',
    intlDescriptionKey: 'cardDescription',
    intlLinkTitleKey: 'cardLinkTitle',
    intlIconAltTextKey: 'cardIconAltText',
    url: 'https://www.coinbase.com/card',
    iconType: 'pictogram',
    iconName: 'cardNavigation'
  }, {
    intlLabelKey: 'privateClient',
    intlDescriptionKey: 'privateClientDescription',
    intlLinkTitleKey: 'privateClientLinkTitle',
    intlIconAltTextKey: 'privateClientIconAltText',
    url: 'https://www.coinbase.com/private-client',
    iconType: 'pictogram',
    iconName: 'privateClientNavigation'
  }, {
    intlLabelKey: 'learningRewards',
    intlDescriptionKey: 'earnDescription',
    intlLinkTitleKey: 'learningRewardsLinkTitle',
    intlIconAltTextKey: 'learningRewardsIconAltText',
    url: 'https://www.coinbase.com/learning-rewards',
    iconType: 'pictogram',
    iconName: 'learningRewardsNavigation'
  }, {
    intlLabelKey: 'coinbaseOne',
    intlDescriptionKey: 'coinbaseOneDescription',
    intlLinkTitleKey: 'coinbaseOneLinkTitle',
    intlIconAltTextKey: 'coinbaseOneIconAltText',
    url: 'https://www.coinbase.com/one',
    iconType: 'pictogram',
    iconName: 'coinbaseOneLogo'
  }, {
    intlLabelKey: 'web3',
    intlDescriptionKey: 'web3Description',
    intlLinkTitleKey: 'web3LinkTitle',
    intlIconAltTextKey: 'web3IconAltText',
    url: 'https://www.coinbase.com/web3',
    iconType: 'pictogram',
    iconName: 'decentralizedWeb3'
  }, {
    intlLabelKey: 'learn',
    intlDescriptionKey: 'learnDescription',
    intlLinkTitleKey: 'learnLinkTitle',
    intlIconAltTextKey: 'learnIconAltText',
    url: 'https://www.coinbase.com/learn',
    iconType: 'pictogram',
    iconName: 'crypto101'
  }]
};
const PRODUCT_LIST = [COLUMN_1];

// Hide learningRewards and privateClient links for UK FinProm compliance
// Private client is moved under businessess for UK users

const EXCLUDED_UK_LABELS = new Set(['learningRewards', 'nft', 'privateClient', 'web3']);
const PRODUCT_LIST_UK = PRODUCT_LIST.map(column => _objectSpread(_objectSpread({}, column), {}, {
  links: column.links.filter(link => !EXCLUDED_UK_LABELS.has(link.intlLabelKey))
}));
export { COLUMN_1, PRODUCT_LIST, PRODUCT_LIST_UK };
//# sourceMappingURL=constants.js.map
